import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import { MenuVertical } from '../MenuVertical';
export const ContextualMenu = ({ items, className, alt }) => {
    const wrapperClassName = classNames('absolute bg-white shadow-lg rounded-lg p-2 w-full max-h-[300px] overflow-auto z-10', className);
    return (_jsx("div", { className: wrapperClassName, "data-testid": "account_menu", children: items.map((item) => (_jsx(MenuVertical, { ...item, alt: alt, size: "sm" }, item.label))) }));
};
